// ---------------------------------------------------------
// Helpers
// ---------------------------------------------------------
// matches polyfill
this.Element && function(ElementPrototype) {
    ElementPrototype.matches = ElementPrototype.matches ||
    ElementPrototype.matchesSelector ||
    ElementPrototype.webkitMatchesSelector ||
    ElementPrototype.msMatchesSelector ||
    function(selector) {
        var node = this, nodes = (node.parentNode || node.document).querySelectorAll(selector), i = -1;
        while (nodes[++i] && nodes[i] != node);
        return !!nodes[i];
    }
}(Element.prototype);

// closest polyfill
this.Element && function(ElementPrototype) {
    ElementPrototype.closest = ElementPrototype.closest ||
    function(selector) {
        var el = this;
        while (el.matches && !el.matches(selector)) el = el.parentNode;
        return el.matches ? el : null;
    }
}(Element.prototype);


// ---------------------------------------------------------
// Popup
// ---------------------------------------------------------
function Popup(options) {

  var self = this;

  this.options = {};
  this.options.mainSelector  = options.mainSelector  || '.popup';
  this.options.closeSelector = options.closeSelector || '.js-close';
  this.options.showOverlay   = options.showOverlay;


  this.DOM = {};
  this.DOM.popup    = document.querySelector(this.options.mainSelector);
  this.DOM.closeBtn = this.DOM.popup.querySelector(this.options.closeSelector);
  this.DOM.overlay  = document.querySelector('.overlay') || this.setOverlay();

  // window.onload = function() {
  //   self.init();
  // }

};

Popup.prototype.setOverlay = function() {

  var overlay = document.createElement('div');

  overlay.className = 'overlay is-hide';

  document.body.appendChild(overlay);

  return overlay;
};

Popup.prototype.init = function() {

  var self = this;

  this.open();
  this.DOM.closeBtn.onclick = function(){
    self.close();
  };

  this.DOM.overlay.onclick = function() {
    self.close();
  };
};

Popup.prototype.open = function(e) {

  if ( this.DOM.popup.classList.contains('is-hide') ) {
    this.DOM.popup.classList.remove('is-hide');
    this.DOM.popup.classList.add('is-show');

    if ( this.options.showOverlay ) {
      this.DOM.overlay.classList.remove('is-hide');
      this.DOM.overlay.classList.add('is-show');
    }

  }
  
};

Popup.prototype.close = function(e) {

  if ( this.DOM.popup.classList.contains('is-show') ) {
    this.DOM.popup.classList.add('is-hide');
    this.DOM.popup.classList.remove('is-show');

    if ( this.options.showOverlay ) {
      this.DOM.overlay.classList.add('is-hide');
      this.DOM.overlay.classList.remove('is-show');
    }
  }

};


// ---------------------------------------------------------
// Tabs
// ---------------------------------------------------------
function Tab(tabDOM) {

  if ( typeof tabDOM === 'string' || tabDOM instanceof String ) {
    var tabDOM = document.querySelector(tabDOM);
  }

  if ( !tabDOM ) {
    return null;
  }

  self = this;

  this.DOM = {};
  this.DOM.tabContainer = tabDOM;

  this.tabs       = this.getTabs();
  this.panes      = this.getPanes();

  this.activeTab  = this.getActiveTab();
  this.activePane = this.getActivePane();

  this.DOM.tabContainer.addEventListener('click', function(e){
    e.preventDefault();

    var target = e.target.closest('.tab');

    if ( target &&  target !== self.activeTab) {
      self.activeTab.classList.remove('active');
      target.classList.add('active');
      self.activeTab = target;

      var tabLink = target.getAttribute('data-content');

      self.activePane.classList.remove('active');
      var targetPane = self.DOM.tabContainer.querySelector(tabLink);
      targetPane.classList.add('active');
      self.activePane = targetPane;
    }
  });

}

Tab.prototype.getTabs = function() {
  return this.DOM.tabContainer.querySelectorAll('li.tab');
};

Tab.prototype.getPanes = function() {
  return this.DOM.tabContainer.querySelectorAll('div.tab-pane');
};

Tab.prototype.getActiveTab = function() {
  return this.DOM.tabContainer.querySelector('li.tab.active');
};

Tab.prototype.getActivePane = function() {
  return this.DOM.tabContainer.querySelector('div.tab-pane.active');
};

// ---------------------------------------------------------
// QuickView
// ---------------------------------------------------------
function QuickView(options) {

  if ( options == null && typeof options !== 'object' ) {
    return null;
  }

  var self = this;

  this.options = {};
  this.options.selector = options.selector || '.js-quick-view';

  this.DOM = {};
  this.DOM.quickViewProducts  = document.querySelectorAll(this.options.selector);
  this.DOM.overlay            = document.querySelector('.overlay');
  this.DOM.quickViewContainer = document.querySelector('.quick-view');
  this.DOM.closeBtn           = document.querySelector('.js-close-btn');


  if ( this.DOM.quickViewProducts.length <= 0 ||  !this.DOM.quickViewContainer ) {
    return null;
  }

  this.products     = this.getProductsObject();
  this.qwContainer  = this.getQWContainerObject();

  this.DOM.closeBtn.addEventListener('click', function(){
    self.close();
  })
}

QuickView.prototype.getProductsObject = function() {

  var self = this,
      productsObject = {},
      product, productHandle, productActionsDOM;

  for ( var i =0, max = this.DOM.quickViewProducts.length; i < max; i++ ) {

    productDOM        = this.DOM.quickViewProducts[i];
    productActionsDOM = productDOM.querySelector('.product__actions');

    productActionsDOM.addEventListener('click', function(e) {
      self.productActionEvents(e);
    });
  }

  return productsObject;
};

QuickView.prototype.getQWContainerObject = function() {

  var qwContainerObject = {};

  qwContainerObject.title         = this.DOM.quickViewContainer.querySelector('.product__title');
  qwContainerObject.image         = this.DOM.quickViewContainer.querySelector('.product-image img');
  qwContainerObject.description   = this.DOM.quickViewContainer.querySelector('.product-description');
  qwContainerObject.price         = this.DOM.quickViewContainer.querySelector('.product-current-price .money');
  qwContainerObject.compare_price = this.DOM.quickViewContainer.querySelector('.product-compare-price .money');
  qwContainerObject.variants      = this.DOM.quickViewContainer.querySelector('.product-variants');
  qwContainerObject.fullLink      = this.DOM.quickViewContainer.querySelector('.product-full-view');

  return qwContainerObject;
};

QuickView.prototype.setProductInfo = function(responseText) {

  if ( !responseText ) {
    return null;
  }

  var productObj = JSON.parse(responseText),
      variant, variantTempl = '';

  this.qwContainer.title.innerHTML         = productObj.title;
  this.qwContainer.image.src               = productObj.featured_image;
  this.qwContainer.description.innerHTML   = productObj.description;
  this.qwContainer.price.innerHTML         = Shopify.formatMoney(productObj.price, "");
  this.qwContainer.fullLink.href           = productObj.url;

  if ( productObj.compare_at_price_max > 0) {
    this.qwContainer.compare_price.innerHTML = Shopify.formatMoney(productObj.compare_at_price_max, "");
  }

  if ( productObj.variants.length > 1 ) {
    this.qwContainer.variants.innerHTML = '';

    for ( var i = 0, max = productObj.variants.length; i < max; i++ ) {
      variant = productObj.variants[i];
      variantTempl = '';

      var select        = document.createElement('select');
      var variantTitle  = document.createElement('span');
      variantTitle.innerHTML = variant.name;
      select.name = 'id';

      for ( var j = 0, max_j = variant.values.length; j < max_j; j++ ) {
        variantTempl += '<option value="' + variant.values[j] + '">' + variant.values[j] + '</option>'; 
      }

      select.innerHTML = variantTempl;

      this.qwContainer.variants.appendChild(variantTitle);
      this.qwContainer.variants.appendChild(select);
    }
  } else {
    var inputId = document.createElement('input');
    inputId.type  = 'hidden';
    inputId.name  = 'id';
    inputId.value = productObj.variants[0].id;
    this.qwContainer.variants.appendChild(inputId);
  }
};

QuickView.prototype.productActionEvents = function(e) {

  var self = this,
      target = e.target,
      quickViewLink, productUrl;

  quickViewLink = target.closest('.quick-preview');

  if (quickViewLink) {

    productUrl = '/products/' + quickViewLink.getAttribute('data-product-handle') + '.js';

    this.request('GET', productUrl, function(responseText){

      self.setProductInfo(responseText);
    });

    this.open();
  }

  // if ( !this.DOM.quickViewContainer ) {
  //   this.DOM.quickViewContainer = this.getQuickViewContainer();
  //   document.body.appendChild(this.DOM.quickViewContainer);
  // }
};

QuickView.prototype.open = function() {

  this.DOM.overlay.classList.add('is-show');
  this.DOM.quickViewContainer.classList.add('is-show');
};

QuickView.prototype.close = function() {

  this.DOM.overlay.classList.remove('is-show');
  this.DOM.quickViewContainer.classList.remove('is-show');
};

QuickView.prototype.request = function(method, url, callback) {

  var xhttp = new XMLHttpRequest();

  xhttp.onreadystatechange = function() {

    if (this.readyState == 4 && this.status == 200) {

      callback(this.responseText);
    } else {
      // console.error(this.responseText)
    }
  };

  xhttp.open(method, url, true);
  xhttp.send();
};





// QuickView.prototype.getQuickViewContainer = function(e) {

//   var qw = {};

//   // main container
//   qw.container = document.createElement('div'); 
//   qw.container.className = 'quick-view';

//   // close button
//   qw.container.closeBtn = document.createElement('button');
//   qw.container.closeBtn.className = 'btn btn-close';

//   //

//   // insert 
//   qw.container.appendChild(qw.container.closeBtn);

//   return qw.container;

//   console.log(e.target);
// };

var quickViews = new QuickView({});

// ---------------------------------------------------------
// Fold Panel
// ---------------------------------------------------------
function FoldPanel() {

  this.foldPanels = document.querySelectorAll('.fold-panel');

  if ( !this.foldPanels ) {
    return null;
  }

  this.init();
}

FoldPanel.prototype.init = function() {
  var self = this,
      panel, toggle;

  for ( var i = 0, max = this.foldPanels.length; i < max; i++ ) {
    toggle = this.foldPanels[i].querySelector('.fold-toggle');

    toggle.addEventListener('click', function(e){

      var panel = e.target.closest('.fold-panel');

      if ( !panel.classList.contains('is-open') ) {
        panel.classList.add('is-open');
      } else {
        panel.classList.remove('is-open');
      }
    });
  }
};

FoldPanel.prototype.togglePanel = function(panel) {
  if ( !panel.classList.contains('is-open') ) {
    panel.classList.add('is-open');
  } else {
    panel.classList.remove('is-open');
  }
};

var foldPanels = new FoldPanel();


// ---------------------------------------------------------
// ClockDown
// ---------------------------------------------------------
function ClockDown(options) {

  if ( options == null && typeof options !== 'object' ) {
    return null;
  }
  var self = this;
  var container, finishDate;

  this.options = {};
  this.options.selector = options.selector || '.clockdown';

  this.DOM = {};
  this.DOM.clockdownContainers = document.querySelectorAll(this.options.selector);

  if ( this.DOM.clockdownContainers <= 0 ) {
    return null;
  }

  for ( var i = 0, max = this.DOM.clockdownContainers.length; i < max; i++ ) {
    container = this.DOM.clockdownContainers[i];
    finishDate = container.getAttribute('data-clockdown-date');
    this.setTime(container, finishDate);
  }
}

ClockDown.prototype.getTimeRemaining = function(finishDate) {

  var finishTime = Date.parse(finishDate);

  var t       = finishTime - Date.parse(new Date()),
      seconds = Math.floor((t / 1000) % 60),
      minutes = Math.floor((t / 1000 / 60) % 60);
      hours   = Math.floor((t / (1000 * 60 * 60)) % 24),
      days    = Math.floor( t / (1000 * 60 * 60 * 24));

  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

ClockDown.prototype.setTime = function(container, finishTime) {

  var daysContainer    = container.querySelector('.days'),
      hoursContainer   = container.querySelector('.hours'),
      minutesContainer = container.querySelector('.minutes'),
      secondsContainer = container.querySelector('.seconds'),
      self = this,
      timeinterval;

  function updateClock() {

    var t = self.getTimeRemaining(finishTime);

    daysContainer.innerHTML    = t.days;
    hoursContainer.innerHTML   = ('0' + t.hours).slice(-2);
    minutesContainer.innerHTML = ('0' + t.minutes).slice(-2);
    secondsContainer.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  timeinterval = setInterval(updateClock, 1000);
}

var clockdown = new ClockDown({});



// ---------------------------------------------------------
// AddToCompare
// ---------------------------------------------------------
function AddToCompare() {

  var self = this;

  this.DOM = {};
  this.DOM.addToCompareBtns = document.querySelectorAll('.add-to-compare');

  if ( this.DOM.addToCompareBtns.length <= 0 ) {
    return null;
  }

  this.activeBtn;

  this.themeObj     = this.getThemeObj() || {};
  this.compareItems = this.themeObj.compare_list || [];

  this.init();

  window.onbeforeunload = function(){
    if ( self.compareItems.length > 0 ) {
      self.saveItems();
    }
  }
}

AddToCompare.prototype.getThemeObj = function() {

  var themeObj;

  if ( Storage ) {
    if ( localStorage.z_theme) {

      themeObj = JSON.parse(localStorage.z_theme);
    } else {

      themeObj = {};
    }
    
  } else if ( document.cookie ) {
    // cookie
  } else {
    // message about old browser or hide buttons
  }

  return themeObj;
};

AddToCompare.prototype.init = function() {

  var self = this;
  
  for ( var i = 0, max = this.DOM.addToCompareBtns.length; i < max; i++ ) {

    var button = this.DOM.addToCompareBtns[i];
    var productHandle = button.getAttribute('data-product-handle');

    if ( this.compareItems.length > 0 && this.compareItems.indexOf(productHandle) > -1 ) {
      this.inTheListMessage(button);
    } else {
      button.addEventListener('click', function(e){

        
        var productHandle = this.getAttribute('data-product-handle');

        if ( self.compareItems.length >= 4 ) {
          
          e.preventDefault();
          self.fullListMessage(this);
          return null;
        }

        if ( self.compareItems.indexOf(productHandle) <= -1 ) {
          e.preventDefault();
          self.compareItems.push(productHandle);
          self.inTheListMessage(this);
        }

      });
    }
  }
};

AddToCompare.prototype.saveItems = function() {
  
  if ( this.compareItems.lenght <= 0 ) {
    return null;
  }

  if ( Storage ) {
    this.saveItemToLocalStorage();
  } else {
    //save into cookie
  }
};

AddToCompare.prototype.saveItemToLocalStorage = function() {

  this.themeObj              = this.getThemeObj();
  this.themeObj.compare_list = this.compareItems;
    
  localStorage.z_theme  = JSON.stringify(this.themeObj);
};

AddToCompare.prototype.inTheListMessage = function(button) {
  button.innerHTML = 'In the compare list';
  button.setAttribute('data-product-handle', '');
};

AddToCompare.prototype.fullListMessage = function(button) {
  if ( button.parentNode.querySelector('.msg') ) {
    return null;
  }

  var msg = document.createElement('p');

  msg.className = 'msg';
  msg.innerHTML = 'The list is full. Please check <a href="/pages/compare-page" title="Check compare list">your compare list</a> and remove some items';

  button.parentNode.insertBefore(msg, button.nextSibling);
};

var instance = new AddToCompare();